import React from 'react';
import PropTypes from 'prop-types';
import {
  Upload,
  message,
} from 'antd';
import {
  APIS,
  config,
} from 'Utils';

class MyUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: props.value || [],
    };
    this.triggerChange = this.triggerChange.bind(this);
    this.checkImgWidthHeight = this.checkImgWidthHeight.bind(this);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.value) {
      this.setState({list: nextProps.value})
    }
  }

  triggerChange(list) {
    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(list);
    }
  }

  checkImgWidthHeight(file) {
    const { maxWidth, maxHeight } = this.props;
    return new Promise((resolve, reject) => {
      // 如果 maxWidth 和 maxHeight 有值，则检测图片尺寸，否则不检测
      if (maxWidth && maxHeight && /image\/*/.test(file.type)) {
        const img = new Image();//创建新的图片对象
        img.src = window.URL.createObjectURL(file);
        img.setAttribute('crossOrigin', 'Anonymous');
        img.onload = function () {
          //图片宽、高超过最大值
          const widthHeightOverflow = img.naturalHeight > maxHeight || img.naturalWidth > maxWidth;
          window.URL.revokeObjectURL(this.src);
          resolve(widthHeightOverflow);
        };
      } else {
        resolve(false);
      }
    });
  }

  render() {
    const self = this;
    const { list } = this.state;
    const { antdUploadProps, maxCount, maxSize, maxWidth, maxHeight, setExtraData } = this.props;
    const uploadProps = {
      name: antdUploadProps.name || 'file',
      accept: antdUploadProps.accept || 'image/*',
      action: APIS.upload,
      fileList: list,
      beforeUpload: (file) => new Promise((resolve, reject) => {
        self.checkImgWidthHeight(file).then((widthHeightOverflow) => {
          // 检测文件类型
          let fileTypeCorrect = true;
          // accept，参考：https://ant.design/components/upload-cn/#API
          // accept，参考：https://developer.mozilla.org/zh-CN/docs/Web/HTML/Element/input/file#accept
          // if (antdUploadProps && antdUploadProps.accept) {
          //   fileTypeCorrect = antdUploadProps.accept.indexOf(file.type) > -1;
          //   if (!fileTypeCorrect) {
          //     message.error('不支持上传这种文件！');
          //   }
          // } else {
          //   fileTypeCorrect = file.type === 'image/jpeg' || file.type === 'image/png';
          //   if (!fileTypeCorrect) {
          //     message.error('只能上传JPG/PNG !');
          //   }
          // }
          // 检测文件大小
          const sizeOverflow = maxSize ? (file.size / 1024 / 1024 > maxSize) : false;
          if (sizeOverflow) {
            message.error(`文件必须小于${maxSize}MB !`);
          }
          // 检测图片尺寸
          if (widthHeightOverflow) {
            message.warning(`建议图片大小：${maxWidth}px * ${maxHeight}px !`);
          }
          // if (fileTypeCorrect && !sizeOverflow && !widthHeightOverflow) {
          if (fileTypeCorrect && !sizeOverflow) {
            resolve();
          } else {
            reject();
          }
        });
      }),
      onChange: info => {
        let fileList = [...info.fileList];
        if (maxCount) {
          fileList = fileList.slice(0 - maxCount);
        }
        fileList = fileList.map(file => {
          if (file.response && file.response.code === 200) {
            file.url = `${config.server}${file.response.data.filePath.split('?')[0]}?id=${file.response.data.id}`;
            file.id = file.response.data.id;
            if(!file.extraData && setExtraData) { // 设置其他业务数据
              file.extraData = file.extraData = setExtraData(file.response.data);
            }
          }
          return file;
        });
        this.setState({ list: fileList }, () => {
          this.triggerChange(fileList);
        });
      },
      ...antdUploadProps,
    };
    if(maxCount && !!this.props.children) {
      return <Upload {...uploadProps}>
        {(!!maxCount && (list.length < maxCount)) ? this.props.children : null}
      </Upload>;
    }
    return <Upload {...uploadProps}>
      {this.props.children}
    </Upload>;
  }
}

MyUpload.propTypes = {
  value: PropTypes.array, // 文件列表
  onChange: PropTypes.func,
  setExtraData: PropTypes.func,
  maxSize: PropTypes.number, // 文件大小, 1Mb
  maxWidth: PropTypes.number, // 图片最大宽度
  maxHeight: PropTypes.number, // 图片最大高度
  maxCount: PropTypes.number, // 文件数量
  children: PropTypes.node,
  antdUploadProps: PropTypes.object, // antd upload 组件参数，参考：https://ant.design/components/upload-cn/#API
};
export default MyUpload;



// WEBPACK FOOTER //
// ./src/components/MyUpload.js